import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 50,
    padding: 12,
  },
});

const LogoFull = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  return (
    <img
      className={classes.img}
      src={isDark ? '/konteks-logo-dark.svg' : '/konteks-logo-light.svg'}
      alt="Konteks"
    />
  );
};

export default LogoFull;
